import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto w-full px-6 lg:px-10 py-14">
        <p className="text-[11px] uppercase tracking-[0.18em] text-teal-700">Terms of use</p>
        <h1 className="mt-3 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">Terms of use</h1>
        <p className="mt-2 text-sm text-slate-500">SmartNote2Self · Kaiventive Holdings Ltd</p>

        <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-slate-700">
          <p>
            By using SmartNote2Self · Biz Resilience Scan ("the Service"), you agree to these Terms.
            If you do not agree, please do not use the Service.
          </p>

          <h2 className="font-display text-xl font-semibold text-slate-900 tracking-tight">1. Service</h2>
          <p>
            The Service helps you think through operational resilience by generating an AI-assisted
            Business Resilience Assessment based on inputs you provide. The Service is provided
            <b> as-is</b>, without warranties of any kind.
          </p>

          <h2 className="font-display text-xl font-semibold text-slate-900 tracking-tight">2. Not professional advice</h2>
          <p className="italic text-slate-600">
            This Business Resilience Assessment was generated using AI-assisted drafting tools based on
            information provided by you. It is intended as operational planning guidance only and does
            not constitute legal, regulatory, audit, or certification advice. Organisations remain
            responsible for validating, implementing, testing, and maintaining their continuity
            arrangements.
          </p>

          <h2 className="font-display text-xl font-semibold text-slate-900 tracking-tight">3. Acceptable use</h2>
          <p>
            You agree not to misuse the Service, including attempting to interfere with security,
            uploading unlawful content, or impersonating others.
          </p>

          <h2 className="font-display text-xl font-semibold text-slate-900 tracking-tight">4. Your content</h2>
          <p>
            You retain ownership of inputs you provide. You grant us a limited licence to process them
            for the sole purpose of delivering the Service. See our{" "}
            <a className="text-teal-700 underline underline-offset-2" href="/privacy">Privacy notice</a>.
          </p>

          <h2 className="font-display text-xl font-semibold text-slate-900 tracking-tight">5. Liability</h2>
          <p>
            To the maximum extent permitted by law, Kaiventive Holdings Ltd is not liable for indirect or
            consequential losses arising from your use of the Service.
          </p>

          <h2 className="font-display text-xl font-semibold text-slate-900 tracking-tight">6. Contact</h2>
          <p>
            Questions:{" "}
            <a className="text-teal-700 underline underline-offset-2" href="mailto:marcelle@smartnote2self.com">
              marcelle@smartnote2self.com
            </a>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
